<template>
  <div class="dealers">

    <div class="pad">
      <b-message type="is-danger" v-if="errMsg.length">{{ errMsg }}</b-message>
    </div>

    <div class="pad-left pad-right flex">
      <b-field label="" :custom-class="sizeClass">
        <b-input type="search" placeholder="Search" v-model="filterStr" :size="sizeClass" />
      </b-field>
      <div class="flex-1"></div>
      <button style="margin-left: 50px;" class="button is-success is-small" @click="$router.push('/dealers/add')">Add Dealer</button>
    </div>

    <div class="flex-table">
      <div class="flex-table-header flex">
        <div class="flex-cell flex-4">Name</div>
        <div class="flex-cell flex-4">Address</div>
        <div class="flex-cell flex-2">Website</div>
        <div class="flex-cell flex-2">Phone</div>
        <div class="flex-cell flex-2">Email</div>
        <div class="flex-cell flex-1"></div>
      </div>
      <div class="flex-table-body">
        <div class="flex-table-row flex" v-for="d in filteredDealers" :key="d.id">
          <div class="flex-cell flex-4">{{ d.name }}</div>
          <div class="flex-cell flex-4">
            <p>{{ d.address }}</p>
            <p>{{ d.city }}, {{ d.state }} {{ d.postcode }}</p></div>
          <div class="flex-cell flex-2">{{ d.website }}</div>
          <div class="flex-cell flex-2">{{ d.phone }}</div>
          <div class="flex-cell flex-2">{{ d.email }}</div>
          <div class="flex-cell flex-1 flex-middle">
            <button class="button is-small is-fullwidth" @click="$router.push(`/dealers/edit/${d.id}`)">
              <font-awesome-icon icon="edit" />edit
            </button>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: 'Dealers',
  data () {
    return {
      dealers: [],
      errMsg: '',
      filterStr: '',
      errMsgTimer: null,
      sizeClass: 'is-small'
    }
  },
  computed: {
    filteredDealers () {
      let str = this.filterStr.toLowerCase().trim()
      return this.dealers
        .filter(item => item.name.toLowerCase().indexOf(str) >= 0)
        .sort((a, b) => a.name.localeCompare(b.name))
    }
  },
  watch: {
    errMsg () {
      clearTimeout(this.errMsgTimer)
      if (this.errMsg.length) {
        this.errMsgTimer = setTimeout(() => { this.errMsg = '' }, 3000)
      }
    }
  },
  created () {
    this.$api('getDealers')
      .then(resp => {
        this.dealers = resp.data
      })
      .catch(err => {
        this.errMsg = err.toString()
      })
  },
  methods: {
  }
}
</script>

<style>
  .products .modal-card-head,
  .products .modal-card-body,
  .products .modal-card-foot {
    min-width: 400px;
  }
</style>
